export enum ContractModeEnum {
  T_M = 'T_M',
  BILL_ONLY = 'BILL_ONLY',
  FIXED_PRICE = 'FIXED_PRICE'
}
